import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@/routes/common/ProtectedRoute';
import { SuspenseWrapper } from '@/routes/common/SuspenseWrapper';

const UserList = lazy(() => import('@/pages/users/List'));
const UserDetail = lazy(() => import('@/pages/users/Detail'));
const UserEdit = lazy(() => import('@/pages/users/Edit'));
const UserCreate = lazy(() => import('@/pages/users/Create'));

export const userRoutes: RouteObject = {
  path: 'users',
  children: [
    {
      path: 'list',
      element: (
        <ProtectedRoute pageKey="page:users:list">
          <SuspenseWrapper>
            <UserList />
          </SuspenseWrapper>
        </ProtectedRoute>
      ),
    },
    {
      path: 'detail/:userUuid',
      element: (
        <SuspenseWrapper>
          <UserDetail />
        </SuspenseWrapper>
      ),
    },
    {
      path: 'create',
      element: (
        <ProtectedRoute pageKey="page:users:create">
          <SuspenseWrapper>
            <UserCreate />
          </SuspenseWrapper>
        </ProtectedRoute>
      ),
    },
    {
      path: 'edit/:id',
      element: (
        <ProtectedRoute pageKey="page:users:edit">
          <SuspenseWrapper>
            <UserEdit />
          </SuspenseWrapper>
        </ProtectedRoute>
      ),
    },
  ],
};
